/* ============================================================
   Luxyor winkelwagen — 28-8-2026
   Hoort bij snippets/cart-drawer.liquid en assets/lx-cart.css

   Alle elementen hieronder zijn custom elements. Dat is met opzet:
   Dawn vervangt bij elke wijziging de hele .drawer__inner, waardoor
   deze elementen opnieuw worden aangemaakt en connectedCallback
   vanzelf weer draait. Losse scripts zouden na de eerste wijziging
   stilvallen.
   ============================================================ */

(function () {
  'use strict';

  var DAGEN = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var DAGEN_DE = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  // Duitse teksten op luxyor.de (html lang="de"), anders Nederlands.
  var DE = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
  // Franse teksten bij html lang="fr".
  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  // Engelse teksten bij html lang="en".
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  // Poolse teksten bij html lang="pl" (11-10-2026).
  var PL = (document.documentElement.lang || '').toLowerCase().indexOf('pl') === 0;
  var DNI = ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę', 'w czwartek', 'w piątek', 'w sobotę'];
  // Deense teksten bij html lang="da" (11-10-2026).
  var DA = (document.documentElement.lang || '').toLowerCase().indexOf('da') === 0;
  var DAGE = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];

  function nuInAmsterdam() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
  }

  function isWerkdag(d) {
    var g = d.getDay();
    return g >= 1 && g <= 5;
  }

  /* ----------------------------------------------------------
     Aftelklok naar de afsluittijd van de verzending.
     Attributen: data-uur (standaard 17), data-kop, data-sub.
     ---------------------------------------------------------- */
  if (!customElements.get('lx-verzendklok')) {
    customElements.define(
      'lx-verzendklok',
      class extends HTMLElement {
        connectedCallback() {
          this.uur = parseInt(this.dataset.uur || '17', 10);
          this.kop = this.querySelector('[data-lx-kop]');
          this.sub = this.querySelector('[data-lx-sub]');
          this.teken();
          this.timer = setInterval(this.teken.bind(this), 30000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        teken() {
          var nu = nuInAmsterdam();
          var afsluit = new Date(nu);
          afsluit.setHours(this.uur, 0, 0, 0);

          if (isWerkdag(nu) && nu < afsluit) {
            var over = Math.floor((afsluit - nu) / 1000);
            var u = Math.floor(over / 3600);
            var m = Math.floor((over % 3600) / 60);
            if (DE) {
              var zeit = u > 0 ? u + ' Std. und ' + m + ' Min.' : m + ' Minuten';
              this.zet(
                'Kostenloser Versand, heute verschickt',
                'Bestelle innerhalb von <b>' + zeit + '</b>, dann geht dein Paket heute raus.'
              );
              return;
            }
            if (FR) {
              var temps = u > 0 ? u + ' h ' + m + ' min' : m + ' minutes';
              this.zet(
                'Livraison gratuite, expédié aujourd\'hui',
                'Commandez dans les <b>' + temps + '</b> et votre colis part aujourd\'hui.'
              );
              return;
            }
            if (DA) {
              var tid = u > 0 ? u + ' t. og ' + m + ' min.' : m + ' min.';
              this.zet(
                'Gratis fragt, sendes i dag',
                'Bestil inden for <b>' + tid + '</b>, så sender vi din pakke i dag.'
              );
              return;
            }
            if (PL) {
              var czas = u > 0 ? u + ' godz. i ' + m + ' min' : m + ' min';
              this.zet(
                'Darmowa wysyłka, wysyłka jeszcze dziś',
                'Zamów w ciągu <b>' + czas + '</b>, a twoja paczka wyjdzie jeszcze dziś.'
              );
              return;
            }
            if (EN) {
              var time = u > 0 ? u + ' h ' + m + ' min' : m + ' minutes';
              this.zet(
                'Free shipping, shipped today',
                'Order within <b>' + time + '</b> and your parcel ships today.'
              );
              return;
            }
            var tijd = u > 0 ? u + ' uur en ' + m + ' min' : m + ' minuten';
            this.zet(
              'Gratis verzending, vandaag verzonden',
              'Bestel binnen <b>' + tijd + '</b> en het is morgen in huis.'
            );
          } else {
            var vd = new Date(nu);
            do {
              vd.setDate(vd.getDate() + 1);
            } while (!isWerkdag(vd));

            var morgen = vd.getDate() === nu.getDate() + 1;
            if (DE) {
              var tag = morgen ? 'morgen' : 'am ' + DAGEN_DE[vd.getDay()];
              var grund = isWerkdag(nu) ? 'Der Versand für heute ist abgeschlossen.' : 'Wir versenden an Werktagen.';
              this.zet(
                'Kostenloser Versand, ' + tag + ' verschickt',
                grund + ' Dein Paket geht <b>' + tag + '</b> raus.'
              );
              return;
            }
            if (FR) {
              var jour = morgen ? 'demain' : JOURS[vd.getDay()];
              var raison = isWerkdag(nu) ? 'Les expéditions du jour sont terminées.' : 'Nous expédions les jours ouvrés.';
              this.zet(
                'Livraison gratuite, expédié ' + jour,
                raison + ' Votre colis part <b>' + jour + '</b>.'
              );
              return;
            }
            if (DA) {
              var dag = morgen ? 'i morgen' : 'på ' + DAGE[vd.getDay()];
              var grund = isWerkdag(nu) ? 'Dagens forsendelser er lukket.' : 'Vi sender på hverdage.';
              this.zet(
                'Gratis fragt, sendes ' + dag,
                grund + ' Din pakke bliver sendt <b>' + dag + '</b>.'
              );
              return;
            }
            if (PL) {
              var dzien = morgen ? 'jutro' : DNI[vd.getDay()];
              var powod = isWerkdag(nu) ? 'Dzisiejsze wysyłki są już zamknięte.' : 'Wysyłamy w dni robocze.';
              this.zet(
                'Darmowa wysyłka, wysyłka ' + dzien,
                powod + ' Twoja paczka wyjdzie <b>' + dzien + '</b>.'
              );
              return;
            }
            if (EN) {
              var day = morgen ? 'tomorrow' : 'on ' + DAYS[vd.getDay()];
              var reason = isWerkdag(nu) ? 'Today\'s shipping has closed.' : 'We ship on working days.';
              this.zet(
                'Free shipping, shipped ' + day,
                reason + ' Your parcel ships <b>' + day + '</b>.'
              );
              return;
            }
            var dag = morgen ? 'morgen' : DAGEN[vd.getDay()];
            var reden = isWerkdag(nu) ? 'De verzending van vandaag is gesloten.' : 'We verzenden op werkdagen.';
            this.zet(
              'Gratis verzending, ' + dag + ' verzonden',
              reden + ' Je pakket gaat <b>' + dag + '</b> de deur uit.'
            );
          }
        }

        zet(kop, sub) {
          if (this.kop) this.kop.textContent = kop;
          if (this.sub) this.sub.innerHTML = sub;
        }
      }
    );
  }

  /* ----------------------------------------------------------
     Bundelladder. De tegels zetten het aantal van de regel en
     laten Dawn het rekenwerk doen: het change-event bubbelt naar
     cart-drawer-items, die de winkelwagen bijwerkt en de hele
     lade opnieuw laat renderen. Geen prijslogica in de browser.
     ---------------------------------------------------------- */
  if (!customElements.get('lx-staffel')) {
    customElements.define(
      'lx-staffel',
      class extends HTMLElement {
        connectedCallback() {
          if (this.gekoppeld) return;
          this.gekoppeld = true;
          this.addEventListener('click', this.opKlik.bind(this));
          this.addEventListener('keydown', this.opToets.bind(this));
        }

        get tegels() {
          return Array.from(this.querySelectorAll('[data-lx-aantal]'));
        }

        opKlik(event) {
          var knop = event.target.closest('[data-lx-aantal]');
          if (!knop) return;
          this.kies(knop);
        }

        // Pijltjestoetsen binnen de groep, zoals bij radioknoppen.
        opToets(event) {
          if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(event.key) === -1) return;
          var knop = event.target.closest('[data-lx-aantal]');
          if (!knop) return;
          event.preventDefault();
          var lijst = this.tegels;
          var i = lijst.indexOf(knop);
          var richting = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
          var volgende = lijst[(i + richting + lijst.length) % lijst.length];
          volgende.focus();
          this.kies(volgende);
        }

        kies(knop) {
          var aantal = parseInt(knop.dataset.lxAantal, 10);
          var invoer = document.getElementById(this.dataset.lxInvoer);
          if (!invoer || isNaN(aantal)) return;
          if (parseInt(invoer.value, 10) === aantal) return;

          this.tegels.forEach(function (t) {
            t.setAttribute('aria-checked', t === knop ? 'true' : 'false');
          });

          invoer.value = aantal;
          invoer.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    );
  }

  /* ----------------------------------------------------------
     Plusknop op een advieskaart. Voegt toe en laat de lade
     opnieuw renderen via Dawn's eigen renderContents.
     ---------------------------------------------------------- */
  if (!customElements.get('lx-toevoegen')) {
    customElements.define(
      'lx-toevoegen',
      class extends HTMLElement {
        connectedCallback() {
          if (this.gekoppeld) return;
          this.gekoppeld = true;
          this.knop = this.querySelector('button');
          if (this.knop) this.knop.addEventListener('click', this.toevoegen.bind(this));
        }

        toevoegen() {
          var lade = document.querySelector('cart-drawer');
          var id = this.dataset.lxVariant;
          if (!id) return;

          this.knop.setAttribute('aria-busy', 'true');

          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify({
              items: [{ id: Number(id), quantity: 1 }],
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          })
            .then(function (r) {
              return r.json();
            })
            .then(function (data) {
              if (data.status) throw new Error(data.description || data.message);
              if (lade && typeof lade.renderContents === 'function') {
                lade.renderContents(data);
              } else {
                window.location.reload();
              }
            })
            .catch(
              function () {
                this.knop.removeAttribute('aria-busy');
                var fouten = document.getElementById('CartDrawer-CartErrors');
                if (fouten) fouten.textContent = DE ? 'Hinzufügen hat nicht geklappt. Versuch es bitte noch einmal.' : FR ? 'L\'ajout n\'a pas fonctionné. Veuillez réessayer.' : EN ? 'Adding did not work. Please try again.' : PL ? 'Nie udało się dodać. Spróbuj ponownie.' : DA ? 'Det lykkedes ikke at tilføje. Prøv igen.' : 'Toevoegen lukte niet. Probeer het nog een keer.';
              }.bind(this)
            );
        }
      }
    );
  }

  /* ----------------------------------------------------------
     Kortingscode. Shopify kan een code alleen via een
     omleiding toepassen; de winkelwagen blijft daarbij intact.
     ---------------------------------------------------------- */
  if (!customElements.get('lx-kortingscode')) {
    customElements.define(
      'lx-kortingscode',
      class extends HTMLElement {
        connectedCallback() {
          if (this.gekoppeld) return;
          this.gekoppeld = true;
          var form = this.querySelector('form');
          if (!form) return;
          form.addEventListener('submit', function (event) {
            event.preventDefault();
            var veld = form.querySelector('input');
            var code = (veld.value || '').trim();
            if (!code) return;
            window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
          });
        }
      }
    );
  }
})();
